

<div class="button-container">
  <button mat-raised-button color="primary" (click)="onSaveClick()" [disabled]="disabled" name="Guardar">
    <mat-icon>save</mat-icon> Guardar
  </button>
</div>
